import React, { useState } from 'react';
import { Tabs, Card, Typography } from 'antd';
import { DatabaseOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import DataTable from './DataTable';
import UserManagement from './UserManagement';

const { Title } = Typography;
const { TabPane } = Tabs;

interface TabAProps {
  // Props for Tab A component
}

const TabA: React.FC<TabAProps> = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('data');

  // Check if current user has permission to manage users
  const canManageUsers = user?.role === 'Admin' || user?.role === 'Leader';

  /**
   * Handle tab change
   * @param key - Active tab key
   */
  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>User Management</Title>
      
      {canManageUsers ? (
        // Admin and Leader users see data table and user management
        <Tabs 
          activeKey={activeTab} 
          onChange={handleTabChange}
          type="card"
          size="large"
        >
          <TabPane 
            tab={
              <span>
                <DatabaseOutlined />
                All Users
              </span>
            } 
            key="data"
          >
            <Card>
              <DataTable dataType="A" title="User List" />
            </Card>
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <UserOutlined />
                Register New User
              </span>
            } 
            key="users"
          >
            <UserManagement />
          </TabPane>
        </Tabs>
      ) : (
        // Employee users only see the data table
        <Card>
          <DataTable dataType="A" title="Admin Data (Tab A)" />
        </Card>
      )}
    </div>
  );
};

export default TabA; 